import Arizona from "./logos/Arizona.png";
import Dallas from "./logos/Dallas.png";
import GreenBay from "./logos/GreenBay.png";
import TampaBay from "./logos/TampaBay.png";
import LARams from "./logos/LARams.png";
import SanFrancisco from "./logos/SanFrancisco.png";
import Philadelphia from "./logos/Philadelphia.png";
import Tennessee from "./logos/Tennessee.png";
import KansasCity from "./logos/KansasCity.png";
import Buffalo from "./logos/Buffalo.png";
import Cincinnati from "./logos/Cincinnati.png";
import LasVegas from "./logos/LasVegas.png";
import NewEngland from "./logos/NewEngland.png";
import Pittsburgh from "./logos/Pittsburgh.png";
import chuckie from "./logos/chuckie.png";
import trophy from "./logos/trophy.png";

export const nfcTeams = [
  { name: "Green Bay", seed: 1, logo: GreenBay, border: 0 },
  { name: "Tampa Bay", seed: 2, logo: TampaBay, border: 0 },
  { name: "Dallas", seed: 3, logo: Dallas, border: 0 },
  { name: "LA Rams", seed: 4, logo: LARams, border: 0 },
  { name: "Arizona", seed: 5, logo: Arizona, border: 0 },
  { name: "San Francisco", seed: 6, logo: SanFrancisco, border: 0 },
  { name: "Philadelphia", seed: 7, logo: Philadelphia, border: 0 }
];
export const afcTeams = [
  { name: "Tennessee", seed: 1, logo: Tennessee, border: 0 },
  { name: "Kansas City", seed: 2, logo: KansasCity, border: 0 },
  { name: "Buffalo", seed: 3, logo: Buffalo, border: 0 },
  { name: "Cincinnati", seed: 4, logo: Cincinnati, border: 0 },
  { name: "Las Vegas", seed: 5, logo: LasVegas, border: 0 },
  { name: "New England", seed: 6, logo: NewEngland, border: 0 },
  { name: "Pittsburgh", seed: 7, logo: Pittsburgh, border: 0 }
];

export const sbtrophy = { name: "trophy", logo: trophy };
